/*
 * Copyright (c) 2022. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { HttpClient } from '@angular/common/http';
import { BankAccount } from '@app/shared/components/bank-accounts/bank-account.model';
import { Model } from '@app/shared/models/model.model';
import { BankStatement } from '@app/banks/bank-accounts/bank-statement.model';

@Injectable({
  providedIn: 'root',
})
export class BankAccountsService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/bank_accounts', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((event: any) => {
          return new BankAccount().deserialize(event);
        });
        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  indexBankStatements(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/bank_account_statements', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((event: any) => {
          return new BankStatement().deserialize(event);
        });
        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  linkBankStatements(paymentsAndStatements: any): Observable<any> {
    return this.http.post('v1/bank_account_statements/link', paymentsAndStatements).pipe(
      map((response: HttpResponse) => {
        return response.data;
      })
    );
  }

  unLinkBankStatements(bankStatementId: number): Observable<any> {
    return this.http.post('v1/bank_account_statements/' + bankStatementId + '/unlink', bankStatementId).pipe(
      map((response: HttpResponse) => {
        return response.data;
      })
    );
  }
  destroyBankStatement(id: number): Observable<any> {
    return this.http.delete('v1/bank_account_statements/' + id);
  }

  update(bankAccount: BankAccount): Observable<BankAccount> {
    return this.http.put('v1/bank_accounts/' + bankAccount.id, bankAccount).pipe(
      map((response: HttpResponse) => {
        return new BankAccount().deserialize(response.data);
      })
    );
  }

  store(bankAccount: BankAccount): Observable<BankAccount> {
    return this.http.post('v1/bank_accounts', bankAccount).pipe(
      map((response: HttpResponse) => {
        return new BankAccount().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/bank_accounts/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new BankAccount().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/bank_accounts/' + id);
  }
}
